import Stack from '@mui/material/Stack';

import { styled } from '@/theme/styled';

const StyledEmptyStateContainer = styled(Stack)(({ theme }) => ({
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  padding: theme.spacing(8, 4),
  margin: theme.spacing(0, 4),
}));

const TextPatternTopRight = styled('img')(() => ({
  position: 'absolute',
  width: 213,
  height: 205,
  top: 0,
  right: 0,
}));

const TextPatternBottomLeft = styled('img')(() => ({
  position: 'absolute',
  width: 267,
  height: 520,
  bottom: 0,
  left: 0,
}));

const ChildrenContainer = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(2),
}));

export { StyledEmptyStateContainer, TextPatternTopRight, TextPatternBottomLeft, ChildrenContainer };
